import { Injectable } from '@angular/core';
import { DataLayerEvent } from './DataLayerEvent';

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  constructor() {}
  pushEventToDataLayer(event: DataLayerEvent) {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      event: event.event,
      ecommerce: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        transaction_id: event.ecommerce.transaction_id,
        value: event.ecommerce.value,
        items: event.ecommerce.items,
      },
    });
  }
}
